/* oxlint-disable typescript/consistent-type-assertions -- lint to the future batch ignore */
import { type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { DropdownSelector } from '@repo/design-system-kit/components/dropdown-selector/dropdown-selector';
import { useEmberService } from '@qonto/react-migration-toolkit/react/hooks';
import type { LocaleCode } from '@repo/shared-config/app/constants/locales';
import { LOCALES_DEFINITION } from '@repo/shared-config/constants/locales';
import styles from './dropdown-language.module.css';

interface DropdownLanguageProps {
  className?: string;
}

export function DropdownLanguage({ className }: DropdownLanguageProps): ReactNode {
  const { locale: currentLocale } = useIntl();

  const localeManager = useEmberService('locale-manager');
  const currentUser = useEmberService('currentUser');

  const locales = Object.values(LOCALES_DEFINITION).map(({ name, code }) => ({
    key: code,
    label: name,
  }));

  const handleLanguageChange = async (languageCode: LocaleCode): Promise<void> => {
    const language = locales.find((l: { key: string }) => l.key === languageCode);
    if (!language || languageCode === currentLocale) return;

    try {
      await localeManager.loadAndSetLocale(languageCode);

      if (currentUser.user) {
        currentUser.user.set('locale', languageCode);
        await currentUser.user.save();
      } else {
        // Storing the locale to set the user's locale after registration/login
        sessionStorage.setItem('logged-out-locale-code', languageCode);
      }
    } catch {
      // Handle error silently
    }
  };

  return (
    <DropdownSelector
      buttonSize="sm"
      className={className}
      data-test-language-dropdown
      items={locales}
      listBoxClassName={styles.listBoxContent}
      onSelectionChange={key => void handleLanguageChange(key as LocaleCode)}
      selectedKey={currentLocale}
    />
  );
}
